import { useState, useEffect } from 'react';
import { authService } from '../../../../services/api';
import { hasConnectedCard } from '../../../../utils/gateways';
import MarketSegmentedControl from '../../../../components/CurrencyModeToggle/MarketSegmentedControl';

/**
 * Mercado/moeda-base do FLUXO na top bar do editor — o mesmo controle
 * segmentado do editar bot. A troca muda o fluxo no editor (`onChange`) e é
 * gravada junto com o fluxo no Salvar.
 */
export default function FlowMarketSettings({ currencyMode = null, onChange }) {
    const [hasCard, setHasCard] = useState(null);

    useEffect(() => {
        authService.gateways.list_gateways()
            .then((res) => setHasCard(hasConnectedCard(res.data?.data)))
            .catch(() => setHasCard(false));
    }, []);

    return <MarketSegmentedControl value={currencyMode} onChange={onChange} hasCard={hasCard} subject="fluxo" />;
}
